var map = {
	"./2020/LetLuisSleep.md": [
		"3a76",
		"chunk-2d0c42e3"
	],
	"./2020/MUSIC.md": [
		"648c",
		"chunk-2d0cf75f"
	],
	"./2020/PEM.md": [
		"e319",
		"chunk-2d22500c"
	],
	"./2020/ThreeAndAHalfGermans.md": [
		"0749",
		"chunk-2d0a47c2"
	],
	"./2021/Diabetes.md": [
		"811b",
		"chunk-2d0dd400"
	],
	"./2021/MentalHealth.md": [
		"2e62",
		"chunk-2d0bdd65"
	],
	"./2021/Stroke.md": [
		"0cfd",
		"chunk-2d0af327"
	],
	"./2022/Group1.md": [
		"ed38",
		"chunk-2d23083a"
	],
	"./2022/Group2.md": [
		"7b0a",
		"chunk-2d0e1772"
	],
	"./2022/Group3.md": [
		"8ef1",
		"chunk-2d0e9d6e"
	],
	"./2022/Group4.md": [
		"9e72",
		"chunk-2d0f0c1d"
	],
	"./2022/Group5.md": [
		"55df",
		"chunk-2d0c8c18"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7d23";
module.exports = webpackAsyncContext;